/**
 * Password visibility toggle for inputs wrapped by PasswordToggleTagHelper.
 *
 * The tag helper emits:
 *   <button data-password-toggle-target="{inputId}" ...>
 *
 * On click the handler toggles the adjacent input's type between
 * "password" and "text" and swaps the eye/eye-off Tabler icon.
 */
function handleToggleClick(this: HTMLButtonElement): void {
    const targetId = this.dataset['passwordToggleTarget'];
    if (!targetId) return;

    const input = document.getElementById(targetId) as HTMLInputElement | null;
    if (!input) return;

    const isPassword = input.type === 'password';
    input.type = isPassword ? 'text' : 'password';

    const icon = this.querySelector<HTMLElement>('i');
    if (icon) {
        icon.className = isPassword ? 'ti ti-eye-off' : 'ti ti-eye';
    }
}

export function initPasswordToggles(root: Document | Element = document): void {
    root.querySelectorAll<HTMLButtonElement>('[data-password-toggle-target]')
        .forEach(btn => btn.addEventListener('click', handleToggleClick));
}
